import produce from 'immer';

import { MULTIMEDIA_TYPES, MultimediaActions, MultimediaState } from './multimediaTypes';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

const initialState: MultimediaState = {
  apiMultimediaRequestState: API_REQUEST_STATE.IDLE,
  apiMultimediaRequestError: null,
  apiAllMultimediaRequestState: API_REQUEST_STATE.IDLE,
  apiAllMultimediaRequestError: null,
  multimedia: {
    gcsUrl: '',
    iri: '',
    name: '',
  },
  allMultimedia: [],
};

export const multimediaReducer = produce((draft: MultimediaState, action: MultimediaActions) => {
  switch (action.type) {
    case MULTIMEDIA_TYPES.RESET:
      draft.multimedia = initialState.multimedia;
      break;
    case MULTIMEDIA_TYPES.SET_API_ALL_MULTIMEDIA_REQUEST_ERROR:
      draft.apiAllMultimediaRequestError = action.payload.apiAllMultimediaRequestError;
      break;
    case MULTIMEDIA_TYPES.SET_API_ALL_MULTIMEDIA_REQUEST_STATE:
      draft.apiAllMultimediaRequestState = action.payload.apiAllMultimediaRequestState;
      break;
    case MULTIMEDIA_TYPES.SET_API_MULTIMEDIA_REQUEST_ERROR:
      draft.apiMultimediaRequestError = action.payload.apiMultimediaRequestError;
      break;
    case MULTIMEDIA_TYPES.SET_API_MULTIMEDIA_REQUEST_STATE:
      draft.apiMultimediaRequestState = action.payload.apiMultimediaRequestState;
      break;
    case MULTIMEDIA_TYPES.GET_ONE_SUCCESS:
      draft.multimedia = action.payload.multimedia;
      break;
    case MULTIMEDIA_TYPES.GET_ALL_SUCCESS:
      draft.allMultimedia = action.payload.multimedia;
      break;
  }
}, initialState);
